import React from "react";
import { Box, Typography } from "@mui/material";
function PlayerView({ viewItem }) {

  // console.log("Lets see:",viewItem);
  return (
    
    <Box
      sx={{
        display:"flex",
        flexDirection:"column",
        gap:1
      }}
    >  
      <Typography
        component="h4"
        variant="h5"
        sx={{
          color:"#000000",
          fontFamily:"Roboto-serif",
          fontWeight:"550",
          textAlign:"center"
        }}
      >Player Detail</Typography>
      <Box
        sx={{
          backgroundColor: "rgb(248,248,248)",
          // width: "110px",
          height: "55px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
          padding: "0.3rem",
          borderRadius: "6px",
        }}
      >
        <Typography sx={{ color: "black", fontWeight: "550",fontFamily:"Roboto-serif" }}>
          Name
        </Typography>
        <Typography sx={{ color: "black",fontFamily:"Roboto-serif"}}>
          {viewItem?.name || ""}
        </Typography>
      </Box>
      <Box
        sx={{
          backgroundColor: "rgb(248,248,248)",
          padding: "0.3rem",
          borderRadius: "6px",
          // width: "110px",
          height: "55px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
        }}
      >
        <Typography sx={{ color: "black", fontWeight: "550",fontFamily:"Roboto-serif"  }}>
          Date Of Birth
        </Typography>
        <Typography sx={{ color: "black",fontFamily:"Roboto-serif"}}>
          {viewItem?.dob || ""}
        </Typography>
      </Box>
      <Box
        sx={{
          backgroundColor: "rgb(248,248,248)",
          padding: "0.3rem",
          borderRadius: "6px",
          // width: "110px",
          height: "55px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
        }}
      >
        <Typography sx={{ color: "black", fontWeight: "550",fontFamily:"Roboto-serif"  }}>
          Club/District
        </Typography>
        <Typography sx={{ color: "black",fontFamily:"Roboto-serif"}}>
          {viewItem?.club || ""}
        </Typography>
      </Box>
      <Box
        sx={{
          backgroundColor: "rgb(248,248,248)",
          padding: "0.3rem",
          borderRadius: "6px",
          // width: "110px",
          height: "55px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
        }}
      >
        <Typography sx={{ color: "black", fontWeight: "550",fontFamily:"Roboto-serif"}}>
          Point
        </Typography>
        <Typography sx={{ color: "black", fontFamily:"Roboto-serif" }}>
          {viewItem?.point || ""}
        </Typography>
      </Box>
      <Box
        sx={{
          backgroundColor: "rgb(248,248,248)",
          padding: "0.3rem",
          borderRadius: "6px",
          // width: "110px",
          height: "55px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
        }}
      >
        <Typography sx={{ color: "black", fontWeight: "550",fontFamily:"Roboto-serif" }}>
          Rank
        </Typography>
        <Typography sx={{ color: "black",fontFamily:"Roboto-serif" }}>
          {viewItem?.player_rank || ""}
        </Typography>
      </Box>
      <Box
        sx={{
          backgroundColor: "rgb(248,248,248)",
          padding: "0.3rem",
          borderRadius: "6px",
          // width: "110px",
          height: "55px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
        }}
      >
        <Typography sx={{ color: "black", fontWeight: "550",fontFamily:"Roboto-serif" }}>
          Contact
        </Typography>
        <Typography sx={{ color: "black", fontFamily:"Roboto-serif" }}>
          {viewItem?.phone_number || ""}
        </Typography>
      </Box>{" "}
      <Box
        sx={{
          backgroundColor: "rgb(248,248,248)",
          padding: "0.3rem",
          borderRadius: "6px",
          // width: "110px",
          height: "55px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
        }}
      >
        <Typography sx={{ color: "black", fontWeight: "550",fontFamily:"Roboto-serif" }}>
          Category
        </Typography>
        <Typography sx={{ color: "black", fontFamily:"Roboto-serif" }}>
          {viewItem?.game_event || ""}
        </Typography>
      </Box>
    </Box>
  );
}
export default PlayerView;